export default "__VITE_ASSET__ziHuQ$Ns__"